var _g, _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwsEc2(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 310,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 310",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f68536"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.754 244.495-29.918 6.826v-193.756l29.918 6.839z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.082 255.931-37.328 10.608v-223.927l37.328 10.595z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.966 267.681-47.884 17.524v-261.259l47.884 17.516z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 245.079-128.034 64.017v-309.096l128.034 64.017z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m102.444 12.763 25.522-12.763v309.096l-25.522-12.759z",
    fill: "#9d5025"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60.325 33.82 19.757-9.878v261.212l-19.757-9.878z",
    fill: "#9d5025"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m27.016 50.477 15.738-7.869v223.88l-15.738-7.874z",
    fill: "#9d5025"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12.836 57.565-12.836 6.418v181.134l12.836 6.414z",
    fill: "#9d5025"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsEc2);
export default __webpack_public_path__ + "static/media/aws-ec2.38cf75494da466bc5ad51c1a9c6ade5b.svg";
export { ForwardRef as ReactComponent };